import * as React from 'react';
import cx from 'classnames';
import Cookies from 'universal-cookie';
// @ts-ignore the types for `react-cookie` are buggy and outdated
import { withCookies } from 'react-cookie';

import getGooglePlayLink from 'utils/getGooglePlayLink';
import Image from 'components/Image';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
// @ts-ignore
import { withUserAgent, UserAgent } from 'lib/currentUserAgent';

import './styles/AppDownloadImageLinks.scss';

type AppDownloadImageLinksAlign = 'left' | 'center';

type Props = {
  align: AppDownloadImageLinksAlign;
  showText: boolean;
  className?: string;
  cookies: Cookies;
  userAgent: UserAgent;
};

type DefaultProps = {
  align: AppDownloadImageLinksAlign;
};

export class AppDownloadImageLinks extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    align: 'center',
  };

  renderLinks() {
    const iosDownloadLink = (
      <Link
        href={LinkConstants.APP_STORE}
        target="_blank"
        className="AppDownloadImageLinks-item"
        eventElementName="AppDownloadImageLinks-item">
        <Image
          src={require('assets/images/app-stores/app-store.svg')}
          alt="Download on the App Store"
          className="AppDownloadImageLinks-item-img"
        />
      </Link>
    );

    const authToken = this.props.cookies.get('auth_token');

    const androidDownloadLink = (
      <Link
        href={getGooglePlayLink(authToken)}
        target="_blank"
        className="AppDownloadImageLinks-item"
        eventElementName="AppDownloadImageLinks-item">
        <Image
          src={require('assets/images/app-stores/google-play.svg')}
          alt="Get it on Google Play"
          className="AppDownloadImageLinks-item-img"
        />
      </Link>
    );

    const { userAgent } = this.props;

    if (userAgent.ios()) {
      return iosDownloadLink;
    }
    if (userAgent.android()) {
      return androidDownloadLink;
    }

    return (
      <div className="AppDownloadImageLinks-links">
        {iosDownloadLink}
        {androidDownloadLink}
      </div>
    );
  }

  render() {
    return (
      <div
        className={cx(
          'AppDownloadImageLinks',
          {
            'AppDownloadImageLinks--left': this.props.align === 'left',
          },
          this.props.className
        )}>
        {this.props.showText && <h3 className="AppDownloadImageLinks-title">Download the app</h3>}
        {this.renderLinks()}
      </div>
    );
  }
}

export default withCookies(withUserAgent(AppDownloadImageLinks));
